import {useContext} from 'react';

import {HttpErrorContext} from '../contexts/HttpErrorStore';

export const useHttpErrorStore = () => useContext(HttpErrorContext);
